import React, { useEffect, useMemo, useState } from 'react'
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from '../../components'
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from '../../components/NextUITable'
import { usePost } from '../../api/reactQueryCustomHooks'
import { apiRoute, linksUrl } from '../../constants/enum'
import { faClose, faCross, faEdit, faPlus, faSquare, faTrash, faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { Button, } from '@nextui-org/react'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmBox from '../../components/ConfirmBox'
import { toast } from 'react-toastify'
import { resetDetailParams, setDetailParams, setNewEntryMode } from '../../state/monthExpEntrySlice'
import { calculateTotal } from '../../Utility/utility'
import { da } from 'date-fns/locale'
import { Drawer } from '@mui/material'
import CreateMonthExpEntry from './CreateMonthExpEntry'

const MonthExpEntryMaster = () => {

    const { compCode, isMultipleCompany } = useSelector((state) => state.company)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [itemToDelete, setItemToDelete] = useState("")
    const INITIAL_VISIBLE_COLUMNS = ["actions", "Year", "MonthName", "UnitName", "ExpName", "ExpTypeName", "Amount"]

    const [openDrawer, setOpenDrawer] = useState(false);


    const { isPending, isError,
        data = [],
        mutate: filterData } = usePost({
            url: apiRoute.monthExpense.fetchEntry,
            queryKey: "Month Expense Entry Data"
        })

    const exportColumns = [
        {
            name: "Year",
            uid: "Year",
        },
        {
            name: "Month",
            uid: "MonthName",
        },
        {
            name: "Unit",
            uid: "UnitName",
        },
        {
            name: "Exp.Name",
            uid: "ExpName",
        },
        {
            name: "Exp.Type",
            uid: "ExpTypeName",
        },
        {
            name: "Amount",
            uid: "Amount",
        },


    ]

    const totalAmt = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Amount",
            }),
        [data])


    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center
        },
        {
            name: "Year",
            uid: "Year",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Month",
            uid: "MonthName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Unit",
            uid: "UnitName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Exp. Name",
            uid: "ExpName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },

        {
            name: "Exp. Type",
            uid: "ExpTypeName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },
        {
            name: "Amount",
            uid: "Amount",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalAmt,
            }
        },

    ]

    const funLoadData = () => {
        filterData({
            data: {
                comp_code: compCode.join(",")
            }
        })
    }


    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        dispatch(resetDetailParams())
        funLoadData()
    }, [])



    let downloadDataFooter = {
        Year: "", MonthName: "", UnitName: "", ExpName: "", ExpTypeName: "", Amount: " Total :- " + totalAmt

    }

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                let obj = {
                    comp_code: row.CompCode,
                    detail_id: row.DetailId,
                }

                dispatch(setDetailParams(obj))
                dispatch(setNewEntryMode(false))
                setOpenDrawer(true)
                //navigate(linksUrl.transaction.journalVoucherEntry.createJournalVoucherEntry)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToDelete({ detail_id: row.DetailId, comp_code: row.CompCode })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },


    ]

    const onSuccessDelete = (data) => {
        setItemToDelete("")
        toast.success("Entry Deleted",
            { position: "top-center" })
        funLoadData();

    }

    const { mutate: FnDeleteEntry } = usePost({
        url: apiRoute.monthExpense.deleteEntry,
        queryKey: "DeleteMonthExpEntry",
        onSuccessTasks: onSuccessDelete,

    })

    const handleConfirmBox = (data) => {
        if (data) {
            FnDeleteEntry({
                data: {
                    comp_code: itemToDelete.comp_code,
                    detail_id: itemToDelete.detail_id,
                }
            })
        }
    }

    const handleAddNew = () => {
        dispatch(resetDetailParams())
        setOpenDrawer(true)
        //navigate(linksUrl.month.journalVoucherEntry.createJournalVoucherEntry)
    }

    const hanldeClick = () => {
        setOpenDrawer(false)
    }

    if (isPending) {
        return <LoadingCard />
    }
    if (isError) {
        return <ErrorCard />
    }

    return (
        <div>
            {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}
            <MainContainer pageName='Monthly Provisional Expense' breadcrumbs={["", "Month Expense"]} >
                <div className="" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <Drawer open={openDrawer} anchor="top"  >
                    <div>
                        <div className="text-center font-semibold uppercase p-1 text-gray-700 border-b-2 border-orange-500">
                            Monthly Provisional Expense Entry
                        </div>
                        <div className='p-5'>
                            <CreateMonthExpEntry />
                            <div className='text-right'>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="sm"
                                    onPress={hanldeClick}
                                    startContent={<FontAwesomeIcon icon={faClose} />}
                                >
                                    Close
                                </Button></div> </div>
                    </div>
                </Drawer>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    exportColumns={exportColumns}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName='MonthExp-list'
                    showAdvanceFilter={false}
                    id="DetailId"
                >
                </NextUITable>

            </MainContainer>

        </div>
    )
}

export default MonthExpEntryMaster